import { NavLink } from 'react-router-dom';

import { IconDashboardTemplates as DashboardTemplatesSVG } from '../../../core';
import { NavigationTab } from '../types';

import CompactTab from './CompactTab';

const DashboardExamples = ({
  isMenuClosed,
  setIsMenuClosed,
}: Pick<NavigationTab, 'isMenuClosed' | 'setIsMenuClosed'>) => {
  const link = '/design-system/sample-dashboards';

  if (isMenuClosed)
    return (
      <CompactTab icon={<DashboardTemplatesSVG />} setIsMenuClosed={setIsMenuClosed} href={link} />
    );

  return (
    <li>
      <NavLink to={link} className={({ isActive }) => (isActive ? 'active' : '')}>
        <div>
          <DashboardTemplatesSVG />
          <span>Dashboard Examples</span>
        </div>
      </NavLink>
    </li>
  );
};

export default DashboardExamples;
